export default "__VITE_ASSET__qS51mtFc__"